import { generateApiClient } from '@guiker/rest-client'

import { AdminApi } from '../api-definition'

export const AdminApiClient = generateApiClient('user-api', AdminApi.routes)
